import useSWR from 'swr';
import fetcher from 'lib/fetcher';

export interface IFavoriteNoteByIdRes {
  note: string | null;
}

const useFavoriteNoteById = (
  favoriteListId: number,
  facilityId: number,
  isDisabled: boolean = false,
) => {
  const { data, error, isLoading, mutate } = useSWR<IFavoriteNoteByIdRes>(
    !isDisabled ? `/favourites/list/${favoriteListId}/note/${facilityId}` : null,
    fetcher.swr,
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
    },
  );
  return { data, error, isLoading, mutate };
};

export default useFavoriteNoteById;
